import { api } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const ReportsAPIs = {


    PostGlobalReceiptsFilter: async function (postJSON, cancel = false) {
        const response = await api.request({
            url: '/school-tour-company/rest/reportservice/globalreceipts',
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            data: postJSON,
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        });
        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        };
    },
}
const cancelAPIObject = defineCancelApiObject(ReportsAPIs)